<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body">
        <form class="form-horizontal">
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Arrival Date</label>
            <div class="col-6 col-md-8 col-lg-9">
              <kendo-datepicker v-model="inbound.arrival_date" class="form-control"></kendo-datepicker>
              <small v-bind:class=" { 'd-none': verification.date } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Document Number</label>
            <div class="col-6 col-md-8 col-lg-9">
              <input type="text" placeholder="Inbound Document Number" class="form-control" v-model="inbound.document_number"/>
              <small v-bind:class=" { 'd-none': verification.document } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Supplier</label>
            <div class="col-6 col-md-8 col-lg-9">
              <vue-select :placeholder="'Select Supplier'" :filterable="false" 
                  :options="suppliers" @search="searchSupplier" :multiple="false" 
                  :ref="'select-supplier'" v-model="inbound.supplier">
                <template slot="no-options">
                  type to search supplier
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name.toUpperCase() }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name.toUpperCase() }}
                  </div>
                </template>
              </vue-select>
              <small v-bind:class=" { 'd-none': verification.supplier } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Product</label>
            <div class="col-6 col-md-8 col-lg-9">
              <vue-select :placeholder="'Select Product'" :filterable="false" 
                  :options="products" @search="searchProduct" :multiple="false" 
                  :ref="'select-product'" v-model="inbound.product">
                <template slot="no-options">
                  type to search product
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                  </div>
                </template>
              </vue-select>
              <small v-bind:class=" { 'd-none': verification.product } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Racks</label>
            <div class="col-6 col-md-8 col-lg-9">
              <input type="text" placeholder="Item Placement Racks" class="form-control" v-model="inbound.racks"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-6 col-md-4 col-lg-3">Principal Price</label>
            <div class="col-6 col-md-8 col-lg-9">
              <numeric-text-box :min="0" :format="'c'" culture="id-ID" 
                class="form-control" :placeholder="'Principal Price'" @change="principalChange"></numeric-text-box>
              <small v-bind:class=" { 'd-none': verification.principal } " class="form-feedback error">This field is required</small>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-primary" @click="submit"><i class="fa fa-save"></i>&nbsp;SUBMIT</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueSelect from 'vue-select'
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper'

export default {
  data () {
    return {
      suppliers: [],
      products: [],
      inbound: {
        arrival_date: moment().format('DD-MM-YYYY'),
        document_number: null,
        supplier: null,
        product: null,
        racks: null,
        principal: null
      },
      verification: {
        document: true,
        date: true,
        product: true,
        supplier: true,
        principal: true
      }
    }
  },
  components: {
    VueSelect,
    NumericTextBox
  },
  methods: {
    searchProduct (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/sales/products/search/' + encodeURIComponent(search) + '/?limit=10&offset=0')
        .then(
          (response) => {
            vm.products = response.data
            loading(false)
          }
        )
    },
    searchSupplier (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/inventory/vendor/?search=' + encodeURIComponent(search))
        .then(
          (response) => {
            vm.suppliers = response.data
            loading(false)
          }
        )
    },
    principalChange (event) {
      this.inbound.principal = parseFloat(event.sender.value().toString())
    },
    submit () {
      if (this.doVerification()) {
        var vm = this
        console.log(vm.inbound)

        var data = new URLSearchParams()
        data.append('document_number', vm.inbound.document_number)
        data.append('arrival_date', moment(vm.inbound.arrival_date, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        data.append('product', vm.inbound.product.code)
        data.append('supplier', vm.inbound.supplier.uid)
        data.append('racks', vm.inbound.racks)
        data.append('principal', vm.inbound.principal)
        // post data
        vm.axios.post('api/inventory/inbound/', data)
          .then(
            (response) => {
              console.log(response)
              vm.$parent.showNotification('Inbound data created', 'success')
              var data = response.data
              vm.$router.push('/inventory/inbound/item/add/' + data.uid)
            }
          )
          .catch(
            (error) => {
              console.log(error)
              console.log(error.response)
              vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
            }
          )
      }
    },
    doVerification () {
      if (!this.inbound.arrival_date || (this.inbound.arrival_date && this.inbound.arrival_date.length === 0)) {
        this.verification.date = false
        return false
      } else {
        this.verification.date = true
      }
      if (!this.inbound.document_number || (this.inbound.document_number && this.inbound.document_number.length === 0)) {
        this.verification.document = false
        return false
      } else {
        this.verification.document = true
      }
      if (!this.inbound.supplier) {
        this.verification.supplier = false
        return false
      } else {
        this.verification.supplier = true
      }
      if (!this.inbound.product) {
        this.verification.product = false
        return false
      } else {
        this.verification.product = true
      }
      if (this.inbound.principal === null || (this.inbound.principal !== null && this.inbound.principal === 0)) {
        this.verification.principal = false
        return false
      } else {
        this.verification.principal = true
      }
      return true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/inbound/AddInbound.vue